import React from 'react'
import { Login } from '../Auth/Login'

const VisitorApp = () => {
  return (
    <Login />
  )
}

export default VisitorApp